import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = () => <div className="spinner"></div>;

export default LoadingSpinner;